export const iconFontAwesomeFoodBeverageMugSaucer = (
	<i className="fa-solid fa-mug-saucer"></i>
);
